import React from "react";
import * as Icon from "@ant-design/icons";

export function getIcon(iconName:string){
    // @ts-ignore
    return React.createElement(Icon[iconName]);
}
